import logoImage from './../assets/images/clover-logo.png';
import FormFooter from "../components/clover/FormFooter";
import {CLIENT_NAME, CLIENT_THEME} from "../utils/constants";
import {getFormFields} from "../components/clover/fields";

const config = {
    clientName: CLIENT_NAME.CLOVER,

    // theme
    theme: CLIENT_THEME.CLOVER,

    // header
    logo: logoImage,
    logoWidth: 304,
    logoHeight: 'auto',
    logoLink: process.env.REACT_APP_PHARO_CONSUMER_CLIENT_RETURN_URL,

    // entry form
    entryForm: {
        title: 'ADVISORY GROUP - APPLICATION',
        showReturn: true,
        showCancel: true,
        customFields: {
            enabled: true,
            fieldGetter: getFormFields,
        },        
    },

    // footer
    footer: {
        copyright: 'Clover Health is a Preferred Provider Organization (PPO) and a Health Maintenance Organization (HMO) with a Medicare contract. Enrollment in Clover Health depends on contract renewal.',
        customFooter: {
            enabled: true,
            component: FormFooter,
        },        
        meta: {
            materialId: 'Y0129_25MX105A_C',
        }
    },

    tracking: {
        mail: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        mo: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        cm: "/?utm_source=cm&utm_medium=phone&utm_campaign=recruit",
        email: "/?utm_source=email&utm_medium=online&utm_campaign=recruit",
        cs: "/?utm_source=cs&utm_medium=phone&utm_campaign=recruit",
        enews: "/?utm_source=enews&utm_medium=online&utm_campaign=recruit",
        mnews: "/?utm_source=mnews&utm_medium=online&utm_campaign=recruit",
        sms: "/?utm_source=sms&utm_medium=phone&utm_campaign=recruit",
    }
}

export default config;
